import { container } from "tsyringe";
export class UseCaseGetCollections {
    async handle() {
        const getCollections = container.resolve("iGetCollections");
        const collections = await getCollections.getCollections();
        return collections;
    }
}
